import { init } from "../init-streaming";
import { JiraSoftwareFeaturesPage } from "../pages/software/jira/features/jira-software-features-page";

init(JiraSoftwareFeaturesPage);
